<template>
  <!-- H5手机号已绑定页面 -->
  <div class="boundTel">
    <div class="telInfo">
      您的手机号 <span> {{ userInfo.tel }} </span> 已被下方账号绑定
    </div>
    <div class="userInfo">
      <div class="userHeadImg">
        <img :src="userInfo.userHeadImg" alt="" />
      </div>
      <div class="centerInfo">
        <div class="userName">{{ userInfo.userName }}</div>
        <div class="nowText">当前绑定</div>
      </div>
    </div>
    <div class="btnstyle loginThisCount" @click="loginThisCount">
      登录此账号
    </div>
    <div class="btnstyle bindOther" @click="bindOther">绑定其它手机号</div>
  </div>
</template>

<script>
import axios from 'axios'
import { Toast } from 'vant'
export default {
  name: '',
  data() {
    return {
      // 已绑定用户信息
      userInfo: {
        tel: '',
        userName: '',
        userHeadImg: '',
        token: ''
      },
      // 来源页
      from: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    document.title = '手机号已被绑定'
    this.userInfo.tel = localStorage.getItem('userMobile')
    this.userInfo.token = localStorage.getItem('newtoken')
    this.userInfo.userHeadImg = localStorage.getItem('userHeadImg')
    this.userInfo.userName = localStorage.getItem('userName')
    this.from = this.$cookies.get('login_origin')
  },
  methods: {
    // 登录已绑定的手机号
    async loginThisCount() {
      // Toast('调接口3：手机号登录，30秒有效期')
      let params = {
        token: this.userInfo.token
      }
      let res = await this.$api.loginByToken(params)
      console.log(res)
      if (res.data.control.status == 200) {
        this.$cookies.set('isThirdNew', '-1', '1d')
        this.$cookies.set('thirdCode', '-1', '1d')
        Toast('登录成功')
        this.getUserInfo()
        setTimeout(() => {
          location.replace(this.from)
        }, 1000);
      } else {
        Toast(res.data.control.message)
      }
    },
    // 绑定其他手机号
    bindOther() {
      console.log('绑定其他手机号')
      // 使用重定向，暂时不知道有没有问题
      this.$router.replace({
        path: '/bindtel'
      })
    },
    // 获取用户信息
    async getUserInfo() {
      axios.defaults.withCredentials = true
      let res = await this.$api.getUserInfo()
      console.log(res)
      if (res.data.status == 200) {
        console.log('获取用户信息')
        this.$cookies.set('token', res.data.data.userToken)
        this.$cookies.set('roomNum', res.data.data.roomNum)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.boundTel {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  padding-top: 0.6rem;
  .telInfo {
    margin-bottom: 0.4rem;
    text-align: center;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    span {
      color: #333333;
    }
  }
  .userInfo {
    width: 6.7rem;
    height: 1.8rem;
    margin: 0 auto;
    margin-bottom: 1rem;
    background: #f5f5f5;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0.3rem;
    .userHeadImg {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.24rem;
      img {
        display: block;
        width: 1.2rem;
        height: 1.2rem;
      }
    }
    .centerInfo {
      .userName {
        margin-bottom: 0.16rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 0.4rem;
      }
      .nowText {
        width: 1.16rem;
        height: 0.4rem;
        background: rgba(5, 222, 109, 0.1);
        border-radius: 0.04rem;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 0.22rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #04b559;
        line-height: normal;
      }
    }
  }
  .btnstyle {
    width: 6.5rem;
    height: 0.9rem;
    margin: 0 auto;
    margin-bottom: 0.4rem;
    border-radius: 0.45rem;
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .loginThisCount {
    background: #e9001d;
    color: #ffffff;
  }
  .bindOther {
    color: #999999;
    background: #f8f9fa;
  }
}
</style>
